module.exports = __webpack_public_path__ + "static/img/retest.6a758bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/neuro/retest.png
// module id = lYqb
// module chunks = 0